import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//CONSTANTS
import { MOBILE } from "../../constants/breakpoints";

function index({
  onClick,
  children,
}: {
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      css={css`
        max-width: 340px;
        width: 85%;
        height: 59.8px;
        position: relative;
        background: transparent;
        border: none;
        margin-top: 36px;
        display: none;
        cursor: pointer;
        @media (max-width: ${MOBILE}px) {
          display: block;
        }
      `}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 341 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={css`
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0px;
          right: 0px;
          top: 0px;
        `}
      >
        <path
          d="M22.815 3.90148C-1.87799 9.68929 0.495966 23.3074 0.496338 32.1596C0.496711 41.0119 0.971203 55.651 37.5358 58.7152C74.1004 61.7793 131.559 59.3961 176.671 58.7152C221.783 58.0342 304.885 61.0984 320.555 55.9915C336.226 50.8846 340.5 41.3517 340.5 25.3501C340.5 9.34852 324.354 1.1778 293.488 1.1778C262.622 1.1778 261.198 2.53933 223.683 2.53933C186.169 2.53933 165.749 0.837341 131.559 1.1778C97.3688 1.51826 47.508 -1.88634 22.815 3.90148Z"
          fill="#FFD550"
        />
      </svg>
      <p
        css={css`
          font-weight: 800;
          font-size: 16px;
          z-index: 100;
          color: black;
          position: relative;
          font-style: italic;
          font-weight: 800;
          font-size: 16px;
        `}
      >
        {children}
      </p>
    </button>
  );
}

export default index;
